import { required } from "@corporate-tailwind/corp-form";
import { CountryDto } from "./country.model";

export class CustomerIdentityProofDto {
    id: Number | null = null;
    itsMeId: String | null = null;
    beEidSn: String | null = null;
    beNationalNumber: String | null = null;
    idDocumentIssuanceDate: Date | null = null;
    idDocumentExpiryDate: Date | null = null;
    idDocumentType: String | null = null;
    issuanceLocality: String | null = null;
    issuingCountry: CountryDto | null = null;

}

export class CustomerIdentityProofSchema extends CustomerIdentityProofDto {
    static schema = {
        id: { type: Number, builderOption: required },
        itsMeId: { type: String, builderOption: required } ,
        beEidSn: { type: String, builderOption: required } ,
        beNationalNumber: { type: String, builderOption: required } ,
        idDocumentIssuanceDate: { type: Date, builderOption: required } ,
        idDocumentExpiryDate: { type: Date, builderOption: required } ,
        idDocumentType: { type: String, builderOption: required } ,
        issuanceLocality: { type: String, builderOption: required } ,
        issuingCountry: {type: CountryDto, builderOption: required } 
    };

}
